import React from "react";
import { connect } from "react-redux";
import BackButton from "../widgets/BackButton";
import {
  getPatientWhatsAppMessagesList,
  loadMorePatientMessages,
  markAsReadWMessage,
  sendPatientWhatsappImage,
  sendPatientWhatsAppMessage,
} from "../../actions/patientWhMessagesActions";
import WhatsappImage from "../../assets/images/whatsapp-sender-icon.svg";
import IconAttachImg from "../../assets/images/attach-document.png";
import { getCompanyFormatFullDate } from "../../helpers/DateUtils";

function getMessageType(mimeType) {
  if (mimeType.startsWith("image/")) return "image";
  if (mimeType.startsWith("video/")) return "video";
  if (mimeType.startsWith("audio/")) return "audio";
  return "document";
}

@connect(({ patientWhMessages, whatsappChatting, clinicId }) => {
  return { patientWhMessages, whatsappChatting, clinicId };
})
export class WhatsAppChattingInterface extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      input: "",
      selectedImage: null,
      selectedImagePreview: "",
      isLoadingMore: false,
    };
    this.chatContentRef = React.createRef();
    this.fileInputRef = React.createRef();
    this.isInitialLoad = true;
  }

  componentDidMount() {
    const { dispatch, location } = this.props;
    const patientKey = new URLSearchParams(location.search).get("pKey");
    dispatch(getPatientWhatsAppMessagesList({ patientKey, start: 0, limit: 20 }));

    this.pollingInterval = setInterval(() => {
      dispatch(getPatientWhatsAppMessagesList({ patientKey, start: 0, limit: 20 }));
    }, 60000);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.patientWhMessages.messages !== this.props.patientWhMessages.messages) {
      if (this.isInitialLoad) {
        this.isInitialLoad = false;
        this.scrollToBottom();
      }
    }
  }

  componentWillUnmount() {
    clearInterval(this.pollingInterval);
  }

  scrollToBottom = () => {
    const { dispatch } = this.props;
    if (this.chatContentRef.current) {
      this.chatContentRef.current.scrollTop = this.chatContentRef.current.scrollHeight;
      const patientKey = new URLSearchParams(this.props.location.search).get("pKey");
      dispatch(markAsReadWMessage({ patientKey }));
    }
  };

  handleScroll = () => {
    const container = this.chatContentRef.current;
    if (!container) return;

    if (container.scrollTop === 0 && !this.state.isLoadingMore) {
      const { messages, totalCount } = this.props.patientWhMessages;
      if (messages.length >= totalCount) return;

      const patientKey = new URLSearchParams(this.props.location.search).get("pKey");
      const prevScrollHeight = container.scrollHeight;

      this.setState({ isLoadingMore: true });

      this.props.dispatch(loadMorePatientMessages({ patientKey })).then(() => {
        this.setState({ isLoadingMore: false });
        requestAnimationFrame(() => {
          container.scrollTop = container.scrollHeight - prevScrollHeight;
        });
      });
    }
  };

  handleInputChange = (e) => {
    this.setState({ input: e.target.value });
  };

  handleImageChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const previewUrl = URL.createObjectURL(file);

    this.setState({
      selectedImage: file,
      selectedImagePreview: previewUrl,
    });
  };

  handleSubmitMessage = () => {
    const { input, selectedImage } = this.state;
    const patientKey = new URLSearchParams(this.props.location.search).get("pKey");

    if (!input.trim() && !selectedImage) return;

    if (selectedImage) {
      const formData = new FormData();
      formData.append("patientKey", patientKey);
      formData.append("photo", selectedImage);
      formData.append("caption", input || "");
      formData.append("messageType", getMessageType(selectedImage.type));

      this.props.dispatch(sendPatientWhatsappImage(formData)).then(() => {
        this.setState({ input: "", selectedImage: null, selectedImagePreview: "" });
        if (this.fileInputRef.current) this.fileInputRef.current.value = null;

        this.props.dispatch(getPatientWhatsAppMessagesList({ patientKey, start: 0, limit: 20 }));
      });
    } else {
      this.props.dispatch(sendPatientWhatsAppMessage({ patientKey, text: input })).then(() => {
        this.setState({ input: "" });
        this.props.dispatch(getPatientWhatsAppMessagesList({ patientKey, start: 0, limit: 20 }));
      });
    }
  };

  render() {
    const { patient } = this.props.whatsappChatting;
    const rawMessages = this.props.patientWhMessages.messages || [];
    const messages = [...rawMessages].reverse();

    return (
      <div style={{ width: "100%", position: "relative" }}>
        <div className="sidebar-header whatsapp-chatting-side-header">
          <div className="clearfix">
            <div className="col-sm-2 pl-1">
              <BackButton
                className="btn-sm pl-0"
                text="Back"
                onClick={this.props.hideWhatsAppChat}
              />
            </div>
            <div className="col-sm-8">
              <div className="whatsapp-note-title text-center">
                <p className="whatsapp-note-title-caption">Messages</p>
                <p className="whatsapp-note-title-chart">Chart#: {patient.chartNumber}</p>
              </div>
            </div>
          </div>
        </div>

        <div
          className="whatsapp-chatting-content"
          ref={this.chatContentRef}
          onScroll={this.handleScroll}
        >
          {this.state.isLoadingMore && (
            <div style={{ textAlign: "center", padding: "8px 0" }}>
              <span>Loading...</span>
            </div>
          )}
          {messages.map((message, index) => {
            const sentMessage = message.status !== "received";
            return (
              <div key={message.id || index} className="whatsapp-chatting-message-wrapper">
                <div
                  className="whatsapp-chatting-message"
                  style={{ marginLeft: sentMessage ? "auto" : undefined }}
                >
                  <div
                    className="whatsapp-chatting-message-content"
                    style={{ backgroundColor: sentMessage ? "#cdd380" : "#dcdcd7" }}
                  >
                    {message?.imageUrl && message.type === "image" && (
                      <img
                        src={message.imageUrl}
                        alt="Sent"
                        style={{ maxWidth: 200, borderRadius: 8 }}
                      />
                    )}
                    {message?.imageUrl && message.type === "video" && (
                      <video
                        src={message.imageUrl}
                        controls
                        style={{ maxWidth: 200, borderRadius: 8 }}
                      />
                    )}
                    {message?.imageUrl && message.type === "audio" && (
                      <audio
                        src={message.imageUrl}
                        controls
                        style={{ maxWidth: 200 }}
                      />
                    )}
                    {message?.imageUrl && message.type === "document" && (() => {
                      const fileName = decodeURIComponent(
                        message.imageUrl.split("/").pop().split("?")[0]
                      ) || "Document";
                      const mimeConfig = {
                        "application/pdf": { label: "PDF", color: "#E53935" },
                        "application/msword": { label: "DOC", color: "#1565C0" },
                        "application/vnd.openxmlformats-officedocument.wordprocessingml.document": { label: "DOCX", color: "#1565C0" },
                        "application/vnd.ms-excel": { label: "XLS", color: "#2E7D32" },
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": { label: "XLSX", color: "#2E7D32" },
                        "application/vnd.ms-powerpoint": { label: "PPT", color: "#D84315" },
                        "application/vnd.openxmlformats-officedocument.presentationml.presentation": { label: "PPTX", color: "#D84315" },
                        "text/plain": { label: "TXT", color: "#546E7A" },
                        "text/csv": { label: "CSV", color: "#2E7D32" },
                        "application/zip": { label: "ZIP", color: "#6D4C41" },
                      };
                      const mimeMatch = message.mimeType && mimeConfig[message.mimeType];
                      const extFallback = fileName.split(".").pop().toUpperCase();
                      const label = mimeMatch ? mimeMatch.label : (extFallback || "FILE");
                      const color = mimeMatch ? mimeMatch.color : "#757575";

                      return (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 10,
                            padding: "8px 12px",
                            background: "#fff",
                            borderRadius: 8,
                            border: "1px solid #e0e0e0",
                          }}
                        >
                          <div
                            style={{
                              width: 40,
                              height: 40,
                              borderRadius: 4,
                              backgroundColor: color,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              color: "#fff",
                              fontSize: 11,
                              fontWeight: "bold",
                              flexShrink: 0,
                            }}
                          >
                            {label}
                          </div>
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div
                              style={{
                                fontSize: 12,
                                fontWeight: 500,
                                color: "#333",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {fileName}
                            </div>
                            <div style={{ fontSize: 11, color: "#888" }}>
                              {label} Document
                            </div>
                          </div>
                          <a
                            href={message.imageUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            title="Preview"
                            style={{
                              padding: 4,
                              borderRadius: 4,
                              display: "flex",
                              alignItems: "center",
                              textDecoration: "none",
                            }}
                          >
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                              <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" fill="#4B5563"/>
                            </svg>
                          </a>
                          <a
                            href={message.imageUrl}
                            download={fileName}
                            title="Download"
                            style={{
                              padding: 4,
                              borderRadius: 4,
                              display: "flex",
                              alignItems: "center",
                              textDecoration: "none",
                            }}
                          >
                            <svg width="18" height="18" viewBox="0 0 19 19" fill="none">
                              <path d="M10.625 1.875C10.625 1.253 10.122.75 9.5.75 8.878.75 8.375 1.253 8.375 1.875V10.407L5.795 7.827C5.355 7.388 4.641 7.388 4.202 7.827 3.763 8.266 3.763 8.98 4.202 9.42L8.702 13.92C9.141 14.359 9.855 14.359 10.295 13.92L14.795 9.42C15.234 8.98 15.234 8.266 14.795 7.827 14.355 7.388 13.641 7.388 13.202 7.827L10.625 10.407V1.875ZM2.75 13.125C1.509 13.125.5 14.134.5 15.375V16.5C.5 17.741 1.509 18.75 2.75 18.75H16.25C17.491 18.75 18.5 17.741 18.5 16.5V15.375C18.5 14.134 17.491 13.125 16.25 13.125H12.682L11.089 14.718C10.21 15.597 8.786 15.597 7.907 14.718L6.318 13.125H2.75Z" fill="#4B5563"/>
                            </svg>
                          </a>
                        </div>
                      );
                    })()}
                    {message?.imageUrl && !message.type && (
                      <img
                        src={message.imageUrl}
                        alt="Sent"
                        style={{ maxWidth: 200, borderRadius: 8 }}
                      />
                    )}
                    <p>{message.text}</p>
                  </div>
                  <p
                    className="whatsapp-chatting-message-date"
                    style={{ textAlign: sentMessage ? "right" : "left" }}
                  >
                    {getCompanyFormatFullDate(message.date)}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {this.state.selectedImage && (
          <div style={{ position: "absolute", bottom: 60, left: 10 }}>
            {this.state.selectedImage.type.startsWith("image/") ? (
              <img
                src={this.state.selectedImagePreview}
                alt="Preview"
                style={{ width: 60, height: 60, objectFit: "cover", borderRadius: 4 }}
              />
            ) : this.state.selectedImage.type.startsWith("video/") ? (
              <video
                src={this.state.selectedImagePreview}
                style={{ width: 60, height: 60, objectFit: "cover", borderRadius: 4 }}
              />
            ) : (
              <div
                style={{
                  width: 60,
                  height: 60,
                  borderRadius: 4,
                  background: "#e0e0e0",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 10,
                  textAlign: "center",
                  padding: 4,
                  wordBreak: "break-all",
                }}
              >
                {this.state.selectedImage.name}
              </div>
            )}
            <button
              onClick={() => {
                this.setState({ selectedImage: null, selectedImagePreview: "" });
                if (this.fileInputRef && this.fileInputRef.current) {
                  this.fileInputRef.current.value = null;
                }
              }}
              style={{
                position: "absolute",
                top: -8,
                right: -8,
                width: 20,
                height: 20,
                borderRadius: "50%",
                background: "red",
                color: "white",
                border: "none",
                cursor: "pointer",
                fontSize: 12,
                lineHeight: "20px",
                textAlign: "center",
              }}
            >
              ×
            </button>
          </div>
        )}

        <div
          style={{
            display: "flex",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "30px",
              position: "relative",
            }}
          >
            <input
              ref={this.fileInputRef}
              type="file"
              accept=".jpeg,.jpg,.png,.webp,.mp4,.3gp,.aac,.amr,.mp3,.m4a,.ogg,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv"
              onChange={this.handleImageChange}
              style={{ opacity: 0, position: "absolute", top: 0, left: 0, right: 0, bottom: 0 }}
            />
            <img src={IconAttachImg} width={20} height={20} alt="Attach icon" />
          </div>

          <div className="whatsapp-chatting-input-wrapper">
            <input
              type="text"
              value={this.state.input}
              onChange={this.handleInputChange}
              placeholder="Typing..."
              className="whatsapp-chatting-input"
            />
            <img
              onClick={this.handleSubmitMessage}
              className="whatsapp-chatting-sender-icon"
              src={WhatsappImage}
              alt="whatsapp sender"
            />
          </div>
        </div>
      </div>
    );
  }
}
